import OverviewPage from '@modules/professional/page/OverviewPage';
import { loader } from '@modules/professional/page/loaders/overview-page-loader.server';
import { ProfessionalPageRevamp } from '~/ui-rocco/pages/professional-detail/ProfessionalPageRevamp';
import { shouldRevalidateLeaf } from '~/modules/root/util/should-revalidate-leaf';
import { getPreloadImageLink } from '~/modules/images';
import type { APHandle } from '~/modules/root';
import { mergeMeta } from '~/modules/seo';
import { useShowProfessionalRevamp } from '@modules/professional/hook/use-professional-layout-data';

export const meta = mergeMeta<typeof loader>(
    () => {
        return [];
    },
    (props) => {
        const { data } = props;
        const bannerImage =
            data?.banners &&
            data.banners.length > 0 &&
            data.banners[0]?.libraryImageFile?.DetailBannerStandard?.Desktop;

        if (bannerImage) {
            if (data.deviceType === 'mobile') {
                return getPreloadImageLink(undefined, bannerImage);
            }
            return getPreloadImageLink(bannerImage);
        }

        return [];
    },
);

export const handle: APHandle = {
    showBannerAndLogoMobile: true,
    isOverviewPage: true,
    hideContactArchiPro: true,
};

/**
 * Switches between the legacy overview page and the revamped editorial
 * professional page (BC-4505) behind the `revamp_2026` feature flag.
 * `?revamp=1` forces the revamp in local dev only.
 */
const ProfessionalOverviewRoute = () => {
    const showRevamp = useShowProfessionalRevamp();

    return showRevamp ? <ProfessionalPageRevamp /> : <OverviewPage />;
};

export { loader };
export const shouldRevalidate = shouldRevalidateLeaf;
export default ProfessionalOverviewRoute;
